import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors } from '@angular/forms';
import { BaseValidator } from 'src/app/modules/tcm-core.module';
import { TranslationService } from 'src/app/services/translation.service';

@Directive({
    selector: '[minimumLength]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: MinimumLengthDirective, multi: true }
    ],
    standalone: false
})
export class MinimumLengthDirective extends BaseValidator {
  
  private minlength: any;

  @Input()
  public get minimumLength(): any {
    return this.minlength;
  }

  public set minimumLength(value: any) {
    this.minlength = value;
    if (this._onChange) this._onChange();
  }

  constructor(private translationService: TranslationService) { 
    super('MinimumLengthValidator');
  }

  protected getValidationResult(control: AbstractControl): ValidationErrors {
    if (control.value == undefined)
      return null;
    
    let result = {} as any;
    if (this.minlength > 0 && control.value.trim().length > 0 && control.value.trim().length < this.minlength) {
      result.error = this.translationService.translate(x => x.Messages.ValidationMessages.MinimumLengthValidator)
        .replace('{0}', this.minlength);
      return this.buildValidationErrorResult(result);
    }

    return null;
  }

}
